import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { P as PaymentMethodTypes } from './Payment.js';
import { d as defineCustomElement$2, P as PaymentMethodOption } from './saved-payment-method.js';
import { d as defineCustomElement$g } from './bank-account-form2.js';
import { d as defineCustomElement$f } from './card-form2.js';
import { d as defineCustomElement$e } from './custom-popper2.js';
import { d as defineCustomElement$d } from './form-control-checkbox2.js';
import { d as defineCustomElement$c } from './form-control-help-text2.js';
import { d as defineCustomElement$b } from './form-control-radio2.js';
import { d as defineCustomElement$a } from './form-control-select2.js';
import { d as defineCustomElement$9 } from './form-control-text2.js';
import { d as defineCustomElement$8 } from './form-control-tooltip2.js';
import { d as defineCustomElement$7 } from './hidden-input2.js';
import { d as defineCustomElement$6 } from './iframe-input2.js';
import { d as defineCustomElement$5 } from './billing-form.js';
import { d as defineCustomElement$4 } from './new-payment-method.js';
import { d as defineCustomElement$3 } from './save-new-payment-method.js';
import { d as defineCustomElement$1 } from './sezzle-payment-method.js';

const PaymentMethodOptions = /*@__PURE__*/ proxyCustomElement(class PaymentMethodOptions extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.savedPaymentMethods = [];
        this.paymentMethodOptions = [];
    }
    async fillBillingForm(fields) {
        const newPaymentMethodElement = this.selectedPaymentMethodOptionRef;
        if (newPaymentMethodElement.fillBillingForm) {
            newPaymentMethodElement.fillBillingForm(fields);
        }
    }
    connectedCallback() {
        this.paymentMethodsChanged();
    }
    paymentMethodsChanged() {
        var _a, _b;
        this.paymentMethodOptions = this.savedPaymentMethods
            .map((paymentMethod) => new PaymentMethodOption(paymentMethod))
            .filter((paymentMethod) => {
            // Don't saved card or bank account if they are disabled
            return ((this.showCard || paymentMethod.type !== PaymentMethodTypes.card) &&
                (this.showAch || paymentMethod.type !== PaymentMethodTypes.bankAccount));
        });
        if (this.showBnpl && ((_a = this.bnpl) === null || _a === void 0 ? void 0 : _a.provider) === 'sezzle' && !this.insuranceToggled) {
            this.paymentMethodOptions.push(new PaymentMethodOption({ id: PaymentMethodTypes.sezzle }));
        }
        if (this.showCard) {
            this.paymentMethodOptions.push(new PaymentMethodOption({ id: PaymentMethodTypes.card }));
        }
        if (this.showAch) {
            this.paymentMethodOptions.push(new PaymentMethodOption({ id: PaymentMethodTypes.bankAccount }));
        }
        if (!this.selectedPaymentMethodId) {
            this.selectedPaymentMethodId = (_b = this.paymentMethodOptions[0]) === null || _b === void 0 ? void 0 : _b.id;
        }
    }
    paymentMethodOptionSelected(event) {
        this.selectedPaymentMethodId = event.detail.id;
    }
    async resolvePaymentMethod(insuranceValidation) {
        var _a;
        return await ((_a = this.selectedPaymentMethodOptionRef) === null || _a === void 0 ? void 0 : _a.resolvePaymentMethod(insuranceValidation));
    }
    async validate() {
        const newPaymentMethodElement = this.selectedPaymentMethodOptionRef;
        const isValid = await newPaymentMethodElement.validate();
        return { isValid: isValid };
    }
    render() {
        var _a;
        return (h(Host, { key: '2cf31e17412eb30afabe6749b86b7d1a6f308114' }, (_a = this.paymentMethodOptions) === null || _a === void 0 ? void 0 : _a.map((paymentMethodOption) => {
            const newCard = paymentMethodOption.id === PaymentMethodTypes.card;
            const newBankAccount = paymentMethodOption.id === PaymentMethodTypes.bankAccount;
            const isSelected = this.selectedPaymentMethodId === paymentMethodOption.id;
            const sezzle = paymentMethodOption.id === PaymentMethodTypes.sezzle;
            if (newCard || newBankAccount) {
                return (h("justifi-new-payment-method", { paymentMethodOption: paymentMethodOption, authToken: this.authToken, "account-id": this.accountId, "is-selected": isSelected, "show-card": this.showCard, "show-ach": this.showAch, paymentMethodGroupId: this.paymentMethodGroupId, hideCardBillingForm: this.hideCardBillingForm, hideBankAccountBillingForm: this.hideBankAccountBillingForm, iframeOrigin: this.iframeOrigin, ref: (el) => {
                        if (isSelected) {
                            this.selectedPaymentMethodOptionRef = el;
                        }
                    } }));
            }
            else if (sezzle) {
                return (h("justifi-sezzle-payment-method", { paymentMethodOption: paymentMethodOption, "is-selected": isSelected, paymentAmount: this.paymentAmount, bnpl: this.bnpl, ref: (el) => {
                        if (isSelected) {
                            this.selectedPaymentMethodOptionRef = el;
                        }
                    } }));
            }
            else if (this.showSavedPaymentMethods) {
                return (h("justifi-saved-payment-method", { paymentMethodOption: paymentMethodOption, "is-selected": isSelected, ref: (el) => {
                        if (isSelected) {
                            this.selectedPaymentMethodOptionRef = el;
                        }
                    } }));
            }
        })));
    }
    static get watchers() { return {
        "savedPaymentMethods": ["paymentMethodsChanged"]
    }; }
}, [0, "justifi-payment-method-options", {
        "showCard": [4, "show-card"],
        "showAch": [4, "show-ach"],
        "showBnpl": [4, "show-bnpl"],
        "showSavedPaymentMethods": [4, "show-saved-payment-methods"],
        "paymentMethodGroupId": [1, "payment-method-group-id"],
        "bnpl": [16],
        "insuranceToggled": [4, "insurance-toggled"],
        "authToken": [1, "auth-token"],
        "accountId": [1, "account-id"],
        "savedPaymentMethods": [16, "saved-payment-methods"],
        "paymentAmount": [2, "payment-amount"],
        "hideCardBillingForm": [4, "hide-card-billing-form"],
        "hideBankAccountBillingForm": [4, "hide-bank-account-billing-form"],
        "iframeOrigin": [1, "iframe-origin"],
        "selectedPaymentMethodId": [32],
        "paymentMethodOptions": [32],
        "fillBillingForm": [64],
        "resolvePaymentMethod": [64],
        "validate": [64]
    }, [[0, "paymentMethodOptionSelected", "paymentMethodOptionSelected"]], {
        "savedPaymentMethods": ["paymentMethodsChanged"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-payment-method-options", "bank-account-form", "card-form", "custom-popper", "form-control-checkbox", "form-control-help-text", "form-control-radio", "form-control-select", "form-control-text", "form-control-tooltip", "hidden-input", "iframe-input", "justifi-billing-form", "justifi-new-payment-method", "justifi-save-new-payment-method", "justifi-saved-payment-method", "justifi-sezzle-payment-method"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-payment-method-options":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PaymentMethodOptions);
            }
            break;
        case "bank-account-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "card-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "hidden-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "iframe-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "justifi-billing-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "justifi-new-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "justifi-save-new-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "justifi-saved-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-sezzle-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { PaymentMethodOptions as P, defineCustomElement as d };
